<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only>
            <slot name="read_only">
                <input :disabled="true" :value="display_value" class="uk-width-1-1" />
            </slot>
        </template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <input-group
            glyph="calendar"
            v-bind="input_group_props"
        >
            <input
                ref="field"
                :id="identifier"
                :name="name"
                :value="date_value(this.format)"
                autocomplete="off"
                :aria-describedby="!!has_slot('hint')?`${identifier}-description`:false"
                :disabled="disabled"
                :placeholder="placeholder"
                :class="{ [`uk-width-${width}`]: true, [`uk-text-${align}`]: true, [`uk-form-${size}`]: true, [`uk-form-${color}`]: true }"
                class="uk-width-1-1"
                @focus="show($event)"
                @blur="blur"
                @keyup.stop="keyup"
            />
        </input-group>
    </form-group>
</template>

<script type="text/javascript">
import is_nibnut_component from "../mixins/IsNibnutComponent"

import FormGroup from "./FormGroup"
import InputGroup from "./InputGroup"

const input_format = "YYYY-MM-DD"
const input_formats = ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss"]

export default {
    mixins: [is_nibnut_component],
    components: {
        FormGroup,
        InputGroup
    },
    mounted () {
        window.UIkit.datepicker(this.$refs.field, this.datepicker_options).on("hide.uk.datepicker", () => {
            this.set_date({ target: this.$refs.field })
        })
    },
    methods: {
        show (event) {
            event.target.select()
        },
        set_date (event, reset_if_invalid = false) {
            const date_string = event.target.value
            if(!date_string) this.date_picked(null)
            else {
                const date_value = this.$moment(date_string, this.format)
                const current_date = this.date_value()
                if(date_value.isValid() && (!current_date || !current_date.isValid() || (!current_date.isSame(date_value, "day")))) this.date_picked(date_value)
                else if(reset_if_invalid) this.date_picked(current_date.isValid() ? current_date : null)
            }
        },
        date_picked (picked_date) {
            const formatted_data = picked_date ? picked_date.format(input_format) : null
            this.$emit("input", formatted_data, this.name)
        },
        date_value (filter = null) {
            if(!this.value) return ""
            const value = this.$moment(this.value, input_formats, true)
            if(!value.isValid()) return null
            if(!filter) return value
            return value.format(filter)
        },
        focus (event) {
            event.target.select()
        },
        keyup (event) {
            if(!event) return
            if(this.inputOnEnter && (event.code === "Enter")) {
                if(document.activeElement && document.activeElement.blur) document.activeElement.blur()
                else this.set_date(event)
            }
        },
        blur (event) {
            // eslint-disable-next-line
            if(!event.relatedTarget || !$(event.relatedTarget).parents(".uk-datepicker").length) this.set_date(event, true)
        }
    },
    computed: {
        datepicker_options () {
            return {
                offsettop: 0,
                // minDate: this.minDate,
                // maxDate: this.maxDate,
                format: this.format,
                pos: this.calendarPosition
            }
        },
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: this.value,
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving
            }
        },
        input_group_props () {
            return {
                glyph: this.glyph,
                width: this.width
            }
        },
        display_value () {
            if(!this.value) return ""
            return this.$moment(this.value).format(this.format)
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: ""
        },
        width: {
            type: String,
            default: "1-1"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|large)$/i),
            default: "normal"
        },
        color: {
            type: String,
            validator: prop => !prop || !!prop.match(/^(danger|success)$/i),
            default: ""
        },
        align: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(left|right|center)$/i),
            default: "left"
        },
        required: {
            type: Boolean,
            required: true
        },
        minDate: {
            default: false
        },
        maxDate: {
            default: false
        },
        format: { // format used for display and input
            type: String,
            default: "MM-DD-YYYY"
        },
        calendarPosition: {
            type: String,
            default: "auto"
        },
        placeholder: {
            type: String,
            default: "(Never)"
        },
        editable: {
            type: Boolean,
            default: true
        },
        inputOnEnter: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        live: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        },
        invalid: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    }
}
</script>
